// export const environment = {
//     prod: false,
//     apiUrl: 'https://apidev.trackon.com.co',
//     urlSocket: 'https://apidev.trackon.com.co',
//     NODE_ENV: 'dev',
// };

export const environment = {
    prod: false,
    apiUrl: 'https://apidev-rds-mercancias.trackon.com.co',
    urlSocket: 'https://apidev-rds-mercancias.trackon.com.co',
    NODE_ENV: 'dev',
    turnstileSiteKey: '0x4AAAAAAC8JXHPJ8F9kBmsz',
};
